import { CaretDown } from "@phosphor-icons/react"
import { Button } from "@tokenterminal/core/ui/button/Button"
import { Icon } from "@tokenterminal/core/ui/icon/Icon"
import { Skeleton } from "@tokenterminal/core/ui/progress/skeleton/Skeleton"
import { SkeletonTextWrapper } from "@tokenterminal/core/ui/progress/skeleton/SkeletonTextWrapper"

type Props = React.HTMLAttributes<HTMLDivElement>

const AccountDropdownSkeleton = (props: Props) => {
  return (
    <div {...props}>
      <div className="!px-2 hidden lg:flex items-center gap-2">
        <Skeleton
          style={{
            width: "22px",
            height: "22px",
            borderRadius: "4px",
          }}
        />
        <div className="hidden lg:flex items-center gap-2">
          <SkeletonTextWrapper>
            <span className="text-sm pointer-events-none select-none">
              Display name here
            </span>
          </SkeletonTextWrapper>
          <Skeleton className="w-6 h-3 !rounded-sm" />
        </div>
        <Icon as={CaretDown} width={14} className="opacity-25 flex-shrink-0" />
      </div>

      {/* Mobile logged in */}
      <Button variant="ghost" className="!px-2 flex lg:hidden">
        <Skeleton
          style={{
            width: "22px",
            height: "22px",
            borderRadius: "4px",
          }}
        />
        <Icon as={CaretDown} width={14} className="opacity-25 flex-shrink-0" />
      </Button>
    </div>
  )
}

export default AccountDropdownSkeleton
